module.exports = __webpack_public_path__ + "media/images/hankyu_hakone_en02-75ec77d6191ef92a1f06333a83c7ac70.jpg";